export default __webpack_public_path__ + "static/media/internship.9e48d79c.svg";